import React from "react";
import GuideTagDisplayRenderer from "./components/GuideTagDisplayRenderer";

export function GuideTagDisplay(base) {
  return {
    getConfig() {
      return {
        name: "GuideTagDisplay",
        displayName: IdealStudio.i18n.t("GuideTagDisplay.PluginName") || "Tag Display",
        category: "objects",
        needsConfigModal: false,
        needsTextEdition: false,
        flavor: "react",
        initialWidth: "20%",
        initialHeight: "6%",
        initialWidthSlide: "20%",
        initialHeightSlide: "6%",
        icon: "label",
        allowFloatingBox: true,
        hideFromRibbon: true,
      };
    },
    getToolbar(state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            tag: {
              __name: IdealStudio.i18n.t("GuideTagDisplay.Tag") || "Tag",
              icon: "label",
              buttons: {
                tagRef: {
                  __name: IdealStudio.i18n.t("GuideTagDisplay.tagRef") || "Tag reference",
                  type: "text",
                  value: state.tagRef || "",
                },
              },
            },
          },
        },
      };
    },
    getRenderTemplate(state, props) {
      return (
        <GuideTagDisplayRenderer
          tagRef={state.tagRef}
          tagValues={props?.tagValues}
          visor={!!props?.visor}
        />
      );
    },
  };
}
